{
  "identities.messages.1010001": "登录",
  "identities.messages.1010002": "使用 {provider} 登录",
  "identities.messages.1010003": "请通过验证确认这是您本人的操作。",
  "identities.messages.1010004": "请完成第二次身份验证挑战。",
  "identities.messages.1010005": "验证",
  "identities.messages.1010006": "身份验证码",
  "identities.messages.1010007": "备用恢复码",
  "identities.messages.1010008": "使用硬件密钥继续",
  "identities.messages.1010009": "继续",
  "identities.messages.1010010": "继续",
  "identities.messages.1010011": "使用硬件密钥登录",
  "identities.messages.1010012": "准备您的 WebAuthn 设备（例如安全密钥、生物识别扫描仪等）并点击“继续”。",
  "identities.messages.1010013": "继续",
  "identities.messages.1010014": "已将代码发送到您提供的地址。如果您没有收到，请检查地址拼写后再次尝试。",
  "identities.messages.1010015": "发送登录码",
  "identities.messages.1010016": "您试图使用“{duplicateIdentifier}”登录，但该电子邮件已被另一个账户使用。请通过以下选项之一登录您的账户，将“{provider}”中的“{duplicateIdentifier}”添加为另一种登录方式。",
  "identities.messages.1010017": "登录并链接",
  "identities.messages.1010018": "确认与 {provider}",
  "identities.messages.1010019": "请求代码以继续",
  "identities.messages.1010021": "使用密钥登录",
  "identities.messages.1010022": "使用密码登录",
  "identities.messages.1010023": "发送到 {address} 的代码",
  "identities.messages.1040001": "注册",
  "identities.messages.1040002": "使用 {provider} 注册",
  "identities.messages.1040003": "继续",
  "identities.messages.1040004": "使用安全密钥注册",
  "identities.messages.1040005": "已将代码发送到您提供的地址。如果您未收到消息，请检查地址拼写并重新尝试注册。",
  "identities.messages.1040006": "发送注册码",
  "identities.messages.1040007": "使用密钥注册",
  "identities.messages.1040008": "返回",
  "identities.messages.1040009": "请选择凭据进行身份验证。",
  "identities.messages.1050001": "您的更改已保存！",
  "identities.messages.1050002": "链接 {provider}",
  "identities.messages.1050003": "取消链接 {provider}",
  "identities.messages.1050004": "取消链接 TOTP 身份验证器应用",
  "identities.messages.1050005": "身份验证器应用二维码",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "显示备用恢复码",
  "identities.messages.1050008": "启用",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "这些是您的备用恢复码。请妥善保管！",
  "identities.messages.1050011": "确认备用恢复码",
  "identities.messages.1050012": "添加安全密钥",
  "identities.messages.1050013": "安全密钥名称",
  "identities.messages.1050014": "秘密于 {used_at, date, long} 使用过",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "禁用此方法",
  "identities.messages.1050017": "身份验证器密钥",
  "identities.messages.1050018": "移除安全密钥“{display_name}”",
  "identities.messages.1050019": "添加密钥",
  "identities.messages.1050020": "移除密钥“{display_name}”",
  "identities.messages.1060001": "您已成功恢复账户。请在接下来的 {privileged_session_expires_at_unix_until_minutes} 分钟内更改密码或设置其他登录方式（例如社交登录）。",
  "identities.messages.1060002": "一封包含恢复链接的电子邮件已发送到您提供的地址。如果您未收到邮件，请检查地址拼写并确保使用注册时使用的地址。",
  "identities.messages.1060003": "一封包含恢复码的电子邮件已发送到您提供的地址。如果您未收到邮件，请检查地址拼写并确保使用注册时使用的地址。",
  "identities.messages.1060004": "恢复码已发送至“{masked_address}”。如果您未收到，请检查地址拼写并确保使用注册时使用的地址。",
  "identities.messages.1060005": "通过提供完整的恢复地址来恢复账户访问权限。",
  "identities.messages.1060006": "您想如何恢复您的账户？",
  "identities.messages.1060007": "返回",
  "identities.messages.1070001": "密码",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "保存",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "提交",
  "identities.messages.1070006": "验证代码",
  "identities.messages.1070007": "电子邮件",
  "identities.messages.1070008": "重新发送验证码",
  "identities.messages.1070009": "继续",
  "identities.messages.1070010": "恢复码",
  "identities.messages.1070011": "验证代码",
  "identities.messages.1070012": "注册码",
  "identities.messages.1070013": "登录码",
  "identities.messages.1070014": "登录并链接凭据",
  "identities.messages.1070015": "请完成验证码挑战以继续。",
  "identities.messages.1070016": "恢复地址",
  "identities.messages.1070017": "电话号码",
  "identities.messages.1080001": "一封包含验证链接的电子邮件已发送到您提供的地址。如果您未收到邮件，请检查地址拼写并确保使用注册时使用的地址。",
  "identities.messages.1080002": "您已成功验证您的电子邮件地址。",
  "identities.messages.1080003": "一封包含验证码的电子邮件已发送到您提供的地址。如果您未收到邮件，请检查地址拼写并确保使用注册时使用的地址。",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "请输入 {property} 并重试。",
  "identities.messages.4000003": "长度必须 >= {min_length}，但实际为 {actual_length}",
  "identities.messages.4000004": "不符合模式 \"{pattern}\"",
  "identities.messages.4000005": "密码不可用，因为 {reason}。",
  "identities.messages.4000006": "提供的凭据无效，请检查您的密码、用户名、电子邮件地址或电话号码的拼写错误。",
  "identities.messages.4000007": "已存在相同标识符（电子邮件、电话、用户名等）的账户。",
  "identities.messages.4000008": "提供的身份验证码无效，请重试。",
  "identities.messages.4000009": "未找到任何登录标识符。是否忘记设置了它们？这也可能是由服务器配置错误引起的。",
  "identities.messages.4000010": "账户尚未激活。是否忘记验证您的电子邮件地址了？",
  "identities.messages.4000011": "您没有设置 TOTP 设备。",
  "identities.messages.4000012": "此备用恢复码已被使用过。",
  "identities.messages.4000013": "您没有设置 WebAuthn 设备。",
  "identities.messages.4000014": "您未设置任何备用恢复码。",
  "identities.messages.4000015": "此账户不存在或未设置安全密钥。",
  "identities.messages.4000016": "此备用恢复码无效。",
  "identities.messages.4000017": "长度必须 <= {max_length}，但实际为 {actual_length}",
  "identities.messages.4000018": "必须 >= {minimum}，但实际为 {actual}",
  "identities.messages.4000019": "必须 > {minimum}，但实际为 {actual}",
  "identities.messages.4000020": "必须 <= {maximum}，但实际为 {actual}",
  "identities.messages.4000021": "必须 < {maximum}，但实际为 {actual}",
  "identities.messages.4000022": "{actual} 不是 {base} 的倍数",
  "identities.messages.4000023": "最多允许 {max_items} 项，但实际有 {actual_items} 项",
  "identities.messages.4000024": "最少需要 {min_items} 项，但实际只有 {actual_items} 项",
  "identities.messages.4000025": "索引 {index_a} 和 {index_b} 的项目相同",
  "identities.messages.4000026": "期望 {allowed_types_list} 类型，但实际为 {actual_type}",
  "identities.messages.4000027": "已存在相同标识符（电子邮件、电话、用户名等）的账户。请登录您的现有账户以链接社交资料。",
  "identities.messages.4000028": "您尝试使用 {credential_identifier_hint} 登录，但已被另一个账户使用。您可以使用 {available_credential_types_list} 进行登录。您可以使用以下社交媒体登录提供商之一进行登录：{available_oidc_providers_list}。",
  "identities.messages.4000029": "必须等于常量 {expected}",
  "identities.messages.4000030": "const 失败",
  "identities.messages.4000031": "密码不可用，因为它与标识符太相似。",
  "identities.messages.4000032": "密码必须至少 {min_length} 个字符长，但实际为 {actual_length}。",
  "identities.messages.4000033": "密码最多只能有 {max_length} 个字符，但实际为 {actual_length}。",
  "identities.messages.4000034": "此密码曾在数据泄露中出现，不能再使用。",
  "identities.messages.4000035": "此账户不存在或未设置验证码登录。",
  "identities.messages.4000036": "提供的特征与与此流程相关联的先前特征不匹配。",
  "identities.messages.4000037": "此账户不存在或未配置登录方法。",
  "identities.messages.4000038": "验证码验证失败，请重试。",
  "identities.messages.4010001": "会话已结束。请重试。",
  "identities.messages.4010002": "未找到用于登录的策略。您是否正确填写了表单？",
  "identities.messages.4010003": "未找到用于注册的策略。您是否正确填写了表单？",
  "identities.messages.4010004": "未找到用于更新设置的策略。您是否正确填写了表单？",
  "identities.messages.4010005": "未找到用于恢复账户的策略。您是否正确填写了表单？",
  "identities.messages.4010006": "未找到用于验证账户的策略。您是否正确填写了表单？",
  "identities.messages.4010007": "请求已成功完成，无法重试。",
  "identities.messages.4010008": "登录码无效或已被使用过，请重新尝试。",
  "identities.messages.4010009": "链接的凭据不匹配。",
  "identities.messages.4010010": "您输入的地址与当前账户中的任何已知地址都不匹配。",
  "identities.messages.4040001": "会话已结束。请重试。",
  "identities.messages.4040002": "请求已成功完成，无法重试。",
  "identities.messages.4040003": "注册码无效或已被使用，请重新尝试。",
  "identities.messages.4050001": "会话已结束。请重试。",
  "identities.messages.4060001": "请求已成功完成，无法重试。",
  "identities.messages.4060002": "恢复流程达到失败状态，必须重新尝试。",
  "identities.messages.4060004": "恢复令牌无效或已被使用，请重新尝试流程。",
  "identities.messages.4060005": "会话已结束。请重试。",
  "identities.messages.4060006": "恢复码无效或已被使用，请重新尝试。",
  "identities.messages.4070001": "验证令牌无效或已被使用，请重新尝试流程。",
  "identities.messages.4070002": "请求已成功完成，无法重试。",
  "identities.messages.4070003": "验证流程达到失败状态，必须重新尝试。",
  "identities.messages.4070005": "会话已结束。请重试。",
  "identities.messages.4070006": "验证码无效或已被使用，请重新尝试。",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "登出",
  "login.registration-button": "注册",
  "login.registration-label": "没有账户？",
  "login.title": "登录",
  "login.subtitle": "使用 {parts} 登录",
  "login.title-aal2": "第二因素身份验证",
  "login.subtitle-aal2": "选择一种方式完成您的第二因素身份验证",
  "login.code.subtitle": "将通过电子邮件发送一个验证码",
  "login.webauthn.subtitle": "请准备您的 WebAuthN 设备",
  "login.totp.subtitle": "请输入由您的身份验证器应用生成的代码",
  "login.lookup_secret.subtitle": "请输入其中一个8位数的备用恢复码",
  "login.title-refresh": "重新认证",
  "login.subtitle-refresh": "使用 {parts} 确认您的身份",
  "login.2fa.go-back": "有什么问题吗？",
  "login.2fa.go-back.link": "返回",
  "login.2fa.method.go-back": "选择另一种方式",
  "recovery.title": "恢复账户",
  "recovery.subtitle": "输入与您的账户关联的标识符以接收一次性访问码",
  "registration.login-button": "登录",
  "registration.login-label": "已有账户？",
  "registration.title": "注册账户",
  "registration.subtitle": "使用 {parts} 注册",
  "settings.navigation-back-button": "返回",
  "settings.subtitle": "更新您的账户设置",
  "settings.title": "账户设置",
  "settings.password.title": "更改密码",
  "settings.password.description": "修改您的密码",
  "settings.profile.title": "个人资料设置",
  "settings.profile.description": "更新您的个人资料信息",
  "settings.webauthn.title": "管理硬件令牌",
  "settings.webauthn.description": "管理您的硬件令牌设置",
  "settings.messages.toast-title.success": "设置已更新",
  "settings.messages.toast-title.error": "无法更新设置",
  "verification.title": "验证您的账户",
  "verification.subtitle": "输入与您的账户关联的电子邮件地址以进行验证",
  "two-step.password.title": "密码",
  "two-step.password.description": "请输入您账户的密码",
  "two-step.code.title": "电子邮件验证码",
  "two-step.code.description": "将通过电子邮件发送一个验证码",
  "two-step.webauthn.title": "安全密钥",
  "two-step.webauthn.description": "使用您的安全密钥进行身份验证",
  "two-step.passkey.title": "密钥（推荐）",
  "two-step.passkey.description": "使用设备的指纹或面部识别功能",
  "two-step.passkey.description.error": "无法加载必要的库以使用您的密钥。请稍后再试。",
  "two-step.totp.title": "使用您的身份验证器应用（TOTP）",
  "two-step.totp.description": "从您的身份验证器应用中使用6位数的一次性代码",
  "two-step.lookup_secret.title": "备用恢复码",
  "two-step.lookup_secret.description": "使用其中一个8位的备用恢复码进行身份验证",
  "input.placeholder": "输入您的 {placeholder}",
  "card.header.parts.oidc": "一个社交提供商",
  "card.header.parts.password.registration": "您的 {identifierLabel} 和密码",
  "card.header.parts.password.login": "您的 {identifierLabel} 和密码",
  "card.header.parts.code": "一次性验证码",
  "card.header.parts.passkey": "密钥",
  "card.header.parts.webauthn": "安全密钥",
  "card.header.parts.totp": "身份验证器应用",
  "card.header.parts.lookup_secret": "备用恢复码",
  "card.header.parts.identifier-first": "您的 {identifierLabel}",
  "misc.or": "或",
  "forms.label.forgot-password": "忘记密码？",
  "forms.label.recover-account": "恢复账户",
  "settings.totp.title": "身份验证器应用",
  "settings.totp.description": "向您的账户添加一个 TOTP 身份验证器应用以提高账户安全性。流行的认证应用包括 LastPass 和 Google Authenticator。",
  "settings.totp.info.not-linked": "要启用，请使用您的身份验证器扫描二维码并输入代码。",
  "settings.totp.info.linked": "您当前已连接了一个身份验证器应用。",
  "settings.lookup_secret.title": "备用恢复码（第二因素）",
  "settings.lookup_secret.description": "恢复码是2FA的安全备份，允许您在丢失2FA设备时重新获得账户访问权限。",
  "settings.oidc.title": "关联的账户",
  "settings.oidc.description": "将社交登录提供商与您的账户连接起来。",
  "settings.oidc.info": "这些提供者的关联账户可用于登录您的账户",
  "settings.webauthn.info": "硬件令牌用于第二因素身份验证或作为带有密钥的第一因素",
  "settings.passkey.title": "管理密钥",
  "settings.passkey.description": "管理您的密钥设置",
  "settings.passkey.info": "管理您的密钥设置",
  "card.footer.select-another-method": "选择另一种方式",
  "account-linking.title": "链接账户",
  "property.password": "密码",
  "property.email": "电子邮件",
  "property.phone": "电话",
  "property.username": "用户名",
  "property.identifier": "标识符",
  "property.code": "验证码",
  "property.recovery_address": "恢复地址",
  "consent.title": "授权 {party}",
  "consent.subtitle": "第三方应用程序希望访问与您的账户关联的信息 {identifier}。",
  "consent.scope.openid.title": "身份",
  "consent.scope.openid.description": "允许该应用验证您的身份。这是认证和信任登录体验所必需的。",
  "consent.scope.offline_access.title": "离线访问",
  "consent.scope.offline_access.description": "允许此应用程序即使您不主动使用它时也能保持您已登录的状态。",
  "consent.scope.profile.title": "个人资料信息",
  "consent.scope.profile.description": "访问您的基本信息，包括用户名、名和姓。",
  "consent.scope.email.title": "电子邮件地址",
  "consent.scope.email.description": "检索您的电子邮件地址及其验证状态。",
  "consent.scope.address.title": "物理地址",
  "consent.scope.address.description": "访问您的邮政地址。",
  "consent.scope.phone.title": "电话号码",
  "consent.scope.phone.description": "检索您的电话号码及其验证状态。",
  "error.title.what-happened": "发生了什么？",
  "error.title.what-can-i-do": "我可以做什么？",
  "error.instructions": "请几分钟后重试或联系网站管理员。",
  "error.footer.text": "报告此错误时，请包括以下信息：",
  "error.footer.copy": "复制",
  "error.action.go-back": "返回",
  "identities.messages.4000039": "新密码必须与旧密码不同。",
  "identities.messages.4000040": "请输入有效的电子邮件地址",
  "identities.messages.4000041": "请输入有效的电话号码",
  "captcha.error": "安全验证失败。请稍后再试。如果问题仍然存在，请联系支持部门。",
  "identities.messages.5000002": "目前没有可用的身份验证方法。请联系系统管理员。",
  "identities.messages.4010011": "此账户已被停用。请联系客服寻求帮助。",
  "identities.messages.1070018": "电子邮件地址或电话号码",
  "identities.messages.1080004": "我们已向您提供的手机号码发送了一条包含验证码的短信。如果您没有收到短信，请检查手机号码是否输入正确，并确保使用您注册时填写的号码。",
  "identities.messages.1080005": "您已成功验证了您的手机号码。",
  "identities.messages.5000003": "您的组织需要使用单点登录 (SSO) 身份验证，但尚未配置任何 SSO 提供程序。请联系系统管理员。",
  "identities.messages.1010024": "使用硬件密钥登录。",
  "identities.messages.1010025": "验证码已发送到您的地址。如果您没有收到，请重试。",
  "identities.messages.4000042": "您尚未设置任何设备身份验证设备。",
  "identities.messages.4000043": "您提供的网页身份验证登录信息无效，请重试。",
  "identities.messages.4000044": "提供的设备身份验证签名无效。",
  "identities.messages.4050002": "您一次只能修改一个地址。请逐一更新每个地址。"
}
